module.exports = __webpack_public_path__ + "Flag-570.07ea0e06fc0c88bbce74fe141f91d1d1.svg";